// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FinancialBenefitsContainer_wrap__3T52v","title":"FinancialBenefitsContainer_title__POB_D"};